export default {
  games: {
    title: 'Fanatical Games | Game info, top picks, what\'s included and more',
    description: 'Everything from Fanatical\'s top picks to all you need to know about the latest upcoming releases. Find out more about characters, factions and what\'s included in your favorite AAA and Indie titles!',
  },
  news: {
    title: 'Fanatical News | Latest game industry news, giveaways, sale announcements and more',
    description: 'Breaking news from the game industry, big giveaways and fantastic sale announcements. Keep up to date on trending topics and much more!',
  },
  develop: {
    title: 'Fanatical Develop | Learn new skills, handy tips for software and applications, eBook collections and more',
    description: 'Get to grips with learning how to use new software and applications, as well as indulging in unique eBook collections for handy tips and enjoyable reads!',
  },
};
